import React from 'react'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'

export const TimelineContentNowLine = React.memo(({ x }) => {
  const { TimelineStyles } = useTimelineStyles()

  return (
    <line
      x1={x}
      y1={0}
      x2={x}
      y2="100%"
      stroke={TimelineStyles.now.fillColor}
      strokeWidth={TimelineStyles.now.width}
      style={{ pointerEvents: 'none' }}
      opacity={0.6}
    />
  )
})
